@if (!options.isEnabled) {
  <ng-container *ngTemplateOutlet="disabledButton"></ng-container>
}

@if (options.isEnabled && options.onClick) {
  <ng-container *ngTemplateOutlet="enabledButton"></ng-container>
}

@if (options.isEnabled && !options.onClick) {
  <ng-container *ngTemplateOutlet="noClick"></ng-container>
}

<ng-template #disabledButton>
  <button
    [ngClass]="[
      !(options.ghostDisabled && options.fullClass)
        ? 'tw-bg-dt-surface-elevated tw-rounded-full !tw-border !tw-border-solid !tw-border-color-border-subtle tw-text-color-text-disabled'
        : 'tw-opacity-40',
      'tw-cursor-default',
      options.fullClass
        ? options.fullClass
        : 'tw-h-12 tw-w-full tw-min-w-min tw-px-6 tw-rounded-full tw-border-none',
      options.class === 'syncButton' ? manageAccountsSync : '',
    ]"
    [disabled]="true"
    tabindex="-1"
    [attr.aria-busy]="isLoading || options.submitting?.() || null"
    [attr.aria-label]="options.ariaLabel || null"
    [attr.data-testid]="options.testId"
  >
    <ng-container *ngTemplateOutlet="textAndIcon"></ng-container>
  </button>
</ng-template>

<ng-template #enabledButton>
  <button
    type="button"
    [ngClass]="[
      !(options.ghostShadow && options.fullClass)
        ? 'hover:tw-shadow-hover active:tw-shadow-inner tw-shadow-button'
        : '',
      options.class ? options.class : '',
      options.fullClass
        ? options.fullClass
        : 'tw-h-12 tw-w-full tw-min-w-min tw-px-6 tw-rounded-full tw-border-none',
      options.class === 'syncButton' ? manageAccountsSync : '',
    ]"
    [disabled]="false"
    (click)="options.onClick()"
    [routerLink]="options.link"
    [attr.aria-busy]="isLoading || options.submitting?.() || null"
    [attr.aria-label]="options.ariaLabel || null"
    [attr.data-testid]="options.testId"
  >
    <ng-container *ngTemplateOutlet="textAndIcon"></ng-container>
  </button>
</ng-template>

<ng-template #noClick>
  <button
    type="button"
    [ngClass]="[
      !options.fullClass
        ? 'tw-h-12 tw-w-full tw-min-w-min tw-px-6 tw-rounded-full tw-border-none'
        : '',
      !(options.ghostShadow && options.fullClass)
        ? 'hover:tw-shadow-hover active:tw-shadow-inner tw-shadow-button'
        : '',
      options.class ? options.class : '',
      options.fullClass ? options.fullClass : '',
    ]"
    [routerLink]="options.link"
    [attr.aria-label]="options.ariaLabel || null"
    [attr.data-testid]="options.testId"
  >
    <ng-container *ngTemplateOutlet="textAndIcon"></ng-container>
  </button>
</ng-template>

<ng-template #textAndIcon>
  <span
    class="tw-flex tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-font-medium tw-items-center"
    [ngClass]="fontClass || ''"
  >
    <svg
      *ngIf="isLoading"
      aria-hidden="true"
      class="tw-h-4 tw-w-4 tw-animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="tw-opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="tw-opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      ></path>
    </svg>
    {{ options.text }}
    <svg *ngIf="options.icon" [ngClass]="options.iconClass || 'tw-h-5 tw-w-5'">
      <use [attr.xlink:href]="'images/sprite.svg#' + options.icon"></use>
    </svg>
    <ng-container *ngIf="options.logoImage">
      <span>|</span>
      <img [src]="options.logoImage" [ngClass]="options.logoClass || 'tw-h-5'" alt="logo" />
    </ng-container>
  </span>
</ng-template>
